export const ACTION = {
    GET_PRODUCT_LIST: 'GET_PRODUCT_LIST',
    GET_SEARCH_LIST: 'GET_SEARCH_LIST',
    GET_PRODUCT_FILTERS: 'GET_PRODUCT_FILTERS',
    POST_SUBSCRIBE_PRODUCT:'POST_SUBSCRIBE_PRODUCT',
    CLEAR_SUBSCRIBE_RESULT:'CLEAR_SUBSCRIBE_RESULT',
    CLEAN_PRODUCT_LIST: 'CLEAN_PRODUCT_LIST',
    APPEND_PRODUCT_LIST: 'APPEND_PRODUCT_LIST',
    GET_PRODUCT_CARD_NAV_CONTENT:'GET_PRODUCT_CARD_NAV_CONTENT',
    //etf apis
    GET_ETF: 'GET_ETF',
};

